import React, { FC, ReactNode } from 'react';

import PropTypes from 'prop-types';

import ACCErrorContextSetter from './ACCErrorContextSetter';
import ACCLaunchDarklySubscriber from './ACCLaunchDarklySubscriber';
import ACCLocaleSubscriber from './ACCLocaleSubscriber';
import { AuthenticatedAnalyticsInitializer } from './Analytics/AuthenticatedAnalyticsInitializer';

const AlloyContextSubscriber: FC<{ children?: ReactNode }> = ({ children }) => (
  <>
    <AuthenticatedAnalyticsInitializer />
    <ACCLocaleSubscriber />
    <ACCLaunchDarklySubscriber />
    <ACCErrorContextSetter />
    {children}
  </>
);

AlloyContextSubscriber.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AlloyContextSubscriber;
